import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c9b6b93&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2c9b6b93&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b6b93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9b6b93')) {
      api.createRecord('2c9b6b93', component.options)
    } else {
      api.reload('2c9b6b93', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c9b6b93&scoped=true", function () {
      api.rerender('2c9b6b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coreProduct/coreCreatStore/index.vue"
export default component.exports